import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UtilsService } from "src/app/utils/utils.service";

@Component({
  selector: "app-time-menu-tab",
  templateUrl: "./time-menu-tab.component.html",
  styleUrls: ["./time-menu-tab.component.scss"],
})
export class TimeMenuTabComponent implements OnInit {
  @Input() activeSideMenu: any;
  @Input() gisMapComp: any;
  is24Active:any;
  is7Active:any;
  iscurrentActive:any;
  is10Active:any;
  isSeasonalActive:any;
  moduleName: any;
  componentName: any;
  isSeamlessActive:any;
  is7WActive:any
  destroy: any = new Subject();
  

  constructor(
    private utils: UtilsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.moduleName = this.router.url.split("/")[1];
    this.componentName = this.router.url.split("/")[2];

    const selectedParamsRef = this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      if (params.hasOwnProperty('forecastLength')) {
        switch (params['forecastLength']) {
          case '-7': this.is7Active = true; this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.isSeamlessActive = false; this.is7WActive = false; break;
          case '-24': this.iscurrentActive = true; this.is24Active = false; this.is10Active = false; this.is7Active = false; this.isSeamlessActive = false; this.is7WActive = false; break;
          case 'seamless': this.isSeamlessActive = true; this.is7Active = false; this.iscurrentActive = false; this.is24Active = false; this.is10Active = false; this.isSeasonalActive = false; this.is7WActive = false; break;
          case '10': this.is10Active = true; this.is24Active = false; this.isSeamlessActive = false; this.is7Active = false; this.iscurrentActive = false; this.isSeasonalActive = false; this.is7WActive = false; break;
          case 'seasonal': this.isSeasonalActive = true; this.is10Active = false; this.is24Active = false; this.isSeamlessActive = false; this.is7Active = false; this.iscurrentActive = false; this.is7WActive = false; break;
          case '-7W': this.is7WActive = true; this.isSeasonalActive = false; this.is10Active = false; this.is24Active = false; this.isSeamlessActive = false; this.is7Active = false; this.iscurrentActive = false; break;
        }
      }
    });
  }

  routeChange(time: string) {
    if (time === this.gisMapComp["params"]["forecastLength"]) {
      return;
    }
    let options = { ...this.gisMapComp["params"] };
    const prevForecastLength = options["forecastLength"];
    options["forecastLength"] = time;
    // When leaving -7W, reset the EUMETSAT-specific params back to defaults
    if (prevForecastLength === '-7W' && time !== '-7W') {
      options["source"] = 'IMD_LONG_RANGE';
      options["aggrType"] = 'mean';
    }
    // If current source is not valid for the new tab, reset to that tab's first valid source
    if (this.gisMapComp && this.gisMapComp.otherOptions) {
      const byForecast = this.gisMapComp.otherOptions['sourceMappingByForecast'];
      const sourceMapping = this.gisMapComp.otherOptions['sourceMapping'];
      if (byForecast && sourceMapping && byForecast[time] && byForecast[time].length > 0) {
        const validSources: string[] = byForecast[time]
          .map((label: string) => sourceMapping[label])
          .filter(Boolean);
        if (validSources.length > 0 && !validSources.includes(options['source'])) {
          options['source'] = validSources[0];
        }
      }
    }
    localStorage.setItem('playBarIndex', '0')
    this.utils.setSelectedParams(options)
    this.iscurrentActive = time === "-24";
    this.is24Active = time === "24";
    this.is10Active = time === "10";
    this.isSeasonalActive = time === "seasonal";
    this.isSeamlessActive = time === "seamless";
    this.is7Active = time === '-7'
    this.is7WActive = time === '-7W'
  }

}
